// extracted by mini-css-extract-plugin
export default {"Container":"VideoImage_Container__ss2bM","DeskWrap":"VideoImage_DeskWrap__5ngfP","ImgDesk":"VideoImage_ImgDesk__89GVH","ToolBox":"VideoImage_ToolBox__0Ao0f"};